import { useTranslation } from 'react-i18next'
import { Input } from '@/components/shadcn/input'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/shadcn/select'
import { HelpLabel } from '@/components/common/help/HelpLabel'
import { HelpText } from '@/components/common/help/HelpText'
import { helpKey } from '@/lib/action-modules/help'
import { ScheduleMonthsDefinitionEditor, type ScheduleMonthsDefinitionEditorProps } from './ScheduleMonthsDefinitionEditor'
import { ScheduleQuarterMode, type ScheduleQuarter } from '@/lib/action-modules/registry/scheduling/types'

export interface ScheduleQuarterDefinitionProps extends ScheduleMonthsDefinitionEditorProps {
  quarterModel: ScheduleQuarter
  onUpdateQuarterModel: (value: ScheduleQuarter) => void
}

export function ScheduleQuarterDefinitionEditor(props: ScheduleQuarterDefinitionProps) {
  const { t } = useTranslation('action-modules-wizard')
  const qd = (key: string) => t(`schedulingStrategy.scheduleDefinition.quarter.${key}`)
  return (
    <div className="flex flex-col gap-2">
      <h4 className="text-sm font-semibold">{qd('title')}</h4>
      <HelpText helpKey={helpKey('schedulingQuarter')} />
      <div className="flex flex-wrap items-end gap-3 pt-1">
        <div className="flex min-w-60 flex-1 flex-col gap-2">
          <HelpLabel helpKey={helpKey('schedulingQuarterScheduleMode')}>{qd('scheduleMode.name')}</HelpLabel>
          <Select
            value={props.quarterModel.mode}
            onValueChange={v => props.onUpdateQuarterModel({ ...props.quarterModel, mode: v as ScheduleQuarterMode })}
          >
            <SelectTrigger className="w-full">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value={ScheduleQuarterMode.None}>{qd('scheduleMode.none')}</SelectItem>
              <SelectItem value={ScheduleQuarterMode.Repeat}>{qd('scheduleMode.repeat')}</SelectItem>
              <SelectItem value={ScheduleQuarterMode.Skip}>{qd('scheduleMode.skip')}</SelectItem>
            </SelectContent>
          </Select>
        </div>
        {props.quarterModel.mode === ScheduleQuarterMode.Skip && (
          <div className="flex flex-1 flex-col gap-2">
            <HelpLabel helpKey={helpKey('schedulingQuarterScheduleModeValue')}>{qd('scheduleMode.value')}</HelpLabel>
            <Input
              type="number"
              value={props.quarterModel.value}
              onChange={e => props.onUpdateQuarterModel({ ...props.quarterModel, value: Number(e.target.value) })}
            />
          </div>
        )}
      </div>
      <div className="flex max-w-xs flex-col gap-2">
        <HelpLabel helpKey={helpKey('schedulingQuarterOffset')}>{qd('offset')}</HelpLabel>
        <Input
          type="number"
          value={props.quarterModel.monthOffsetInsideQuarter}
          onChange={e =>
            props.onUpdateQuarterModel({ ...props.quarterModel, monthOffsetInsideQuarter: Number(e.target.value) })
          }
        />
      </div>
      <ScheduleMonthsDefinitionEditor
        monthModel={props.monthModel}
        onUpdateMonthModel={props.onUpdateMonthModel}
        weekModel={props.weekModel}
        onUpdateWeekModel={props.onUpdateWeekModel}
        dayModel={props.dayModel}
        onUpdateDayModel={props.onUpdateDayModel}
      />
    </div>
  )
}
